const BUDGET_QUERY_RANGE_ENUM = {
  TODAY: 'TODAY',
  THIS_WEEK: 'THIS_WEEK',
  THIS_MONTH: 'THIS_MONTH',
};

export default BUDGET_QUERY_RANGE_ENUM;
